<script>
  import { layoutMethods, coreEloadProviderMethods } from "@/state/helpers";
  import { required } from "vuelidate/lib/validators";
  import Swal from 'sweetalert2';
  import { getModuleAccess } from '@/router/helper.js';

  /**
   * E-Load Provider Form component
   */
  export default {
    page: {
      title: "E-Load Provider Form"
    },
    computed: {
    },
    data() {
      return {
        title: "E-Load Provider Form",
        provider_id: 0,
        form:{
          status          : true,
          provider_name   : null,
        },
        formExitChecker:{
          status          : true,
          provider_name   : null,
        },
        submitted : false,
        eloadProviderModule: {
          access: {
            create: false,
            read: false,
            update: false,
            delete: false
          }
        }
      };
    },
    validations: {
      form: {
        status              : {required},
        provider_name       : {required}
      },
    },
    methods: {
      ...layoutMethods,
      ...coreEloadProviderMethods,
      cancelRouting(){
          this.$router.go(-1);
      },
      async handleSubmit(){
        this.submitted = true
        this.$v.$touch();
        if (!this.$v.form.$invalid){
            console.log(":: FORM ::", JSON.stringify(this.form));
            await this.actionCoreEloadProviderAPIPOST({
                action: (this.provider_id > 0 ? "update":"create"),
                params: this.provider_id > 0 ? {...this.form,"provider_id":this.provider_id}:this.form
            })
            .then((res) => {
              console.log(res);
              
              // Check if the response status is "ok" or "err"
              if (res.status === "ok") {
                Swal.fire({
                  title: (this.provider_id > 0 ? "Updated" : "Created") + " Successful!",
                  text: res["message"],
                  icon: "success",
                  confirmButtonColor: '#6f42c1',
                  confirmButtonText: 'OK',
                  customClass: {
                    popup: 'swal-popup',
                    confirmButton: 'btn btn-primary'
                  }
                });
                this.formExitChecker = {...this.form}
                this.cancelRouting();
              } else {
                let errorIcon = 'error';
                let errorTitle = (this.provider_id > 0 ? "Update" : "Create") + " Failed!";
                
                // Check if it's a duplicate error (status code 409)
                if (res.statusCode === 409 || (res.message && res.message.includes('already exists'))) {
                  errorIcon = 'warning';
                  // errorTitle = "Duplicate Provider";
                }
                
                Swal.fire({
                  title: errorTitle,
                  text: res.message || "An unexpected error occurred",
                  icon: errorIcon,
                  confirmButtonColor: errorIcon === 'warning' ? '#6E66D9' : '#dc3545',
                  confirmButtonText: 'OK',
                  customClass: {
                    popup: 'swal-popup',
                    confirmButton: errorIcon === 'warning' ? 'btn btn-warning' : 'btn btn-danger'
                  }
                });
              }
            }).catch((e)=>{
              console.log("error while creating/updating provider", e);
              
              Swal.fire({
                title: "Request Failed!",
                text: e.message || "An unexpected error occurred",
                icon: 'error',
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'OK',
                customClass: {
                  popup: 'swal-popup',
                  confirmButton: 'btn btn-danger'
                }
              });
            });
        }
      },
      async getInformation(){
        await this.actionCoreEloadProviderAPIPOST({
            action: "info",
            params: {"provider_id":this.provider_id}
        })
        .then((res) => {
          this.form                       = {...res["message"]}
          this.formExitChecker            = {...res["message"]}
        }).catch((e)=>{
          console.log("error while getting details",e);
        });
      },
      leaveform(next){
          if(JSON.stringify(this.form) == JSON.stringify(this.formExitChecker)){
            next();
            return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{
                  return;
              }
          })
      },
    },
    async mounted(){
      this.provider_id = this.$route.params.id;
      this.changeTitle({title: (this.provider_id == 0 ? "Add":"Edit") + ' E-Load Provider'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'E-Load Core Manager', to: { name: 'E-Load Core Provider'} },
          { text: 'E-Load Provider Form', to: { name: 'E-Load Provider Form'} }
        ]
      });
      if(this.provider_id > 0){
        // alert("hey eedited");
        this.getInformation();
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Provider')
        .then((access) => this.eloadProviderModule.access = access);
    },
    beforeRouteLeave(to, from, next) {
        if(JSON.stringify(this.form) != JSON.stringify(this.formExitChecker)){
          this.leaveform(next);
        }else{
          next();
        }
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-8">
            <!-- offset-md-3 -->
            <div class="card">
                <div class="card-body">
                  
                  <form class="px-4" @submit.prevent="handleSubmit()">
                    <div class="row">
                      <label v-if="(provider_id <= 0 || isNaN(provider_id)) && !eloadProviderModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a provider.</label>
                      <label v-else-if="provider_id > 0 && !eloadProviderModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a provider.</label>
                      <div class="col-md-12 mb-3"><!--start active status-->
                        <div class="form-check form-switch">
                          <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                          <input
                            class="form-check-input"
                            v-model="form.status"
                            type="checkbox"
                            id="flexSwitchCheckDefault"
                          />
                        </div>
                      </div><!--end active status-->
                      <div class="mb-3 col-md-12"><!--Provider Name-->
                        <label class="form-label small fw-bold">Provider Name<span style="color: red">*</span></label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="form.provider_name"
                          placeholder="Enter Provider Name"
                          :class="{
                              'is-invalid': submitted && $v.form.provider_name.$error,
                          }"
                        />
                        <div v-if="submitted && $v.form.provider_name.$error"
                          class="text-danger">
                          <span v-if="!$v.form.provider_name.required">This value is required.</span>
                        </div>
                      </div><!--Provider Name-->
                    </div>
                    <div class="row mb-2 px-3"><!--start of row button group-->
                      <div class="col-md-12 mt-3 ta-right p-0">
                        <b-button variant="primary" class="w-sm me-2" type="submit" :disabled="provider_id > 0 ? !eloadProviderModule.access.update : !eloadProviderModule.access.create">{{provider_id == 0 ? "Save":"Update"}}</b-button>
                        <b-button variant="light" class="w-sm ml-2" type="button" @click="cancelRouting" >Cancel</b-button>
                      </div>
                    </div><!--end of row button group-->

                    </form>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>